import moment from 'moment';
import { AccountDetailsType } from '../features/settings/types';

export const accountDetailsFormToParams = (
  formData: AccountDetailsType,
  identifier: fhir4.Identifier[] | undefined,
) => {
  return {
    resource: {
      resourceType: 'Patient',
      ...(identifier && identifier.length != 0 && { identifier: identifier }),
      active: true,
      address: [
        {
          city: formData.city,
          country: formData.country?.value,
          line: [formData.street ?? '', formData.unit ?? ''],
          postalcode: formData.zip,
          state: formData.state?.value,
          use: 'home',
        },
      ],
      birthDate: moment(formData.birthdate).format('YYYY-MM-DD'),
      gender: formData.sex?.value,
      name: [
        {
          family: formData.lastName,
          given: [formData.firstName, ...(formData.middleName ? [formData.middleName] : [])],
          use: 'usual',
        },
      ],
      telecom: [
        {
          isNew: true,
          system: 'email',
          value: formData.email,
        },
        {
          isNew: false,
          system: 'phone',
          value: formData.phone,
          countryCode: '+1',
          country: 'US',
        },
      ],
    },
  };
};

export default accountDetailsFormToParams;
